import db from '@/plugins/dexie';
import { USER_STORAGE } from '@/constants/STORAGE';
import apirecebimentoweb from '@/services/api-recebimentoweb';
import moment from 'moment-timezone';
import { geraDataNuvem } from '../geradata';

import { testarConexaoApi } from '../isonline';
import { SetupEnvioLocal } from '../atualizalocal';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

function extraiBearerToken(tokenString) {
  if (!tokenString) return '';
  try {
    const tokenObj = JSON.parse(tokenString);
    return tokenObj?.token || tokenObj;
  } catch (e) {
    return tokenString;
  }
}

export default async function enviaMovimentacaoVeiculo(idLocal = null) {
  const conectou = await testarConexaoApi();
  if (!conectou) return;

  const tokenString = sessionStorage.getItem('auth:token') || sessionStorage.getItem('auth:tokenlocal');
  if (!tokenString) return;
  const bearerToken = extraiBearerToken(tokenString);

  let movimentacoes = await db.movimentacaoveiculo.toArray();
  if (idLocal) {
    const idNum = Number(idLocal);
    movimentacoes = movimentacoes.filter((m) => m.id === idLocal || m.id === idNum);
  } else {
    movimentacoes = movimentacoes.filter((m) => !m.movdeletar && !m.movenviado && !m.enviado && (!m.movidnuvem || !m.movdatanuvem || (m.movdataalteracao && m.movdatanuvem && moment(m.movdataalteracao).isAfter(moment(m.movdatanuvem)))));
  }

  if (movimentacoes.length === 0) return;

  let houveAlteracao = false;

  const idusuario = await getSessionStorage(USER_STORAGE.useidusuario, sessionStorage.getItem('user:useidnuvem'));

  for (const item of movimentacoes) {
    if (item.movidnuvem) {
      console.log('put movimentacaoveiculo - ', item);
      const payload = {
        id: item.movidnuvem,
        movidmovimentacaoveiculo: item.movidmovimentacaoveiculo || null,
        movidveiculo: item.movidveiculo,
        movideventoveiculo: item.movideventoveiculo,
        movidfornecedor: item.movidfornecedor,
        movvalortipo: item.movvalortipo,
        movdata: item.movdata,
        movidatividade: item.movidatividade,
        movobservacao: item.movobservacao,
        movtipo: item.movtipo,
        movtipomanutencao: item.movtipomanutencao,
        movidpessoaexecutor: item.movidpessoaexecutor || idusuario,
        movidpropriedade: item.movidpropriedade,
        movgarantiaate: item.movgarantiaate || null,
        movidempresa: item.movidempresa,
        movdataalteracao: geraDataNuvem(),
        movidmovimentacaonuvem: item.movidmovimentacaonuvem,
      };

      try {
        const res = await apirecebimentoweb.put(`/movimentacaoveiculo/${item.movidnuvem}`, payload, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });
        const dadosResp = Array.isArray(res.data) ? res.data[0] : (res.data?.data || res.data);
        const alteracao = geraDataNuvem(dadosResp?.movdataalteracao || dadosResp?.updated || new Date());
        const idMovimentacaoFinal = dadosResp?.movidmovimentacaoveiculo || dadosResp?.id || item.movidmovimentacaoveiculo || null;
        await db.movimentacaoveiculo.update(item.id, {
          ...(idMovimentacaoFinal ? { movidmovimentacaoveiculo: idMovimentacaoFinal } : {}),
          movdataalteracao: alteracao,
          movdatanuvem: alteracao,
          movenviado: 1,
          enviado: 1,
        });
        houveAlteracao = true;
      } catch (err) {
        console.error('Erro ao atualizar movimentacaoveiculo:', err);
      }
    } else {
      console.log('post movimentacaoveiculo - ', item);
      const payload = {
        movidmovimentacaoveiculo: item.movidmovimentacaoveiculo || null,
        movidveiculo: item.movidveiculo,
        movideventoveiculo: item.movideventoveiculo,
        movidfornecedor: item.movidfornecedor,
        movvalortipo: item.movvalortipo,
        movdata: item.movdata,
        movidatividade: item.movidatividade,
        movobservacao: item.movobservacao,
        movtipo: item.movtipo,
        movtipomanutencao: item.movtipomanutencao,
        movidpessoaexecutor: item.movidpessoaexecutor || idusuario,
        movidpropriedade: item.movidpropriedade,
        movgarantiaate: item.movgarantiaate || null,
        movidempresa: item.movidempresa,
        movdataalteracao: item.movdataalteracao ? geraDataNuvem(item.movdataalteracao) : geraDataNuvem(),
        movidmovimentacaonuvem: item.movidmovimentacaonuvem,
      };

      try {
        const res = await apirecebimentoweb.post('/movimentacaoveiculo', payload, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });
        const dadosResp = Array.isArray(res.data) ? res.data[0] : (res.data?.data || res.data);
        const alteracao = geraDataNuvem(dadosResp?.movdataalteracao || dadosResp?.created || new Date());
        const idNuvemGerado = dadosResp?.id
          || dadosResp?.movidnuvem
          || dadosResp?.movidmovimentacaoveiculo
          || dadosResp?.insertId;
        const idMovimentacaoFinal = dadosResp?.movidmovimentacaoveiculo
          || dadosResp?.id
          || item.movidmovimentacaoveiculo
          || null;

        await db.movimentacaoveiculo.update(item.id, {
          movidnuvem: idNuvemGerado,
          movidmovimentacaoveiculo: idMovimentacaoFinal,
          movdataalteracao: alteracao,
          movdatanuvem: alteracao,
          movenviado: 1,
          enviado: 1,
        });
        houveAlteracao = true;

        // Atualiza vínculo nos itens locais caso existam
        if (idNuvemGerado) {
          const itensFilhos = await db.itemmovimentacaoveiculo
            .filter((it) => it.imvidmovimentacaoveiculo === item.id
              || it.imvidmovimentacaoveiculo === Number(item.id)
              || String(it.imvidmovimentacaoveiculo) === String(item.id)
              || (item.uuid && (it.imvidmovimentacaoveiculo === item.uuid || it.movimentacaouuid === item.uuid))
              || it.imvidmovimentacaonuvem === idNuvemGerado)
            .toArray();
          for (const itemFilho of itensFilhos) {
            const updates = {
              imvidmovimentacaonuvem: idNuvemGerado,
            };
            if (typeof idMovimentacaoFinal === 'number' && !Number.isNaN(idMovimentacaoFinal)) {
              updates.imvidmovimentacaoveiculo = idMovimentacaoFinal;
            }
            await db.itemmovimentacaoveiculo.update(itemFilho.id, updates);
          }
        }
      } catch (err) {
        console.error('Erro ao cadastrar movimentacaoveiculo:', err.response?.data || err.message || err);
      }
    }
  }

  if (houveAlteracao) {
    try {
      await SetupEnvioLocal({ silent: true });
    } catch (err) {
      console.warn('Aviso: Falha ao executar SetupEnvioLocal pós-envio de movimentação de veículo:', err);
    }
  }
}

export async function deletaMovimentacaoVeiculo() {
  const conectou = await testarConexaoApi();
  if (!conectou) return;

  const tokenString = sessionStorage.getItem('auth:token') || sessionStorage.getItem('auth:tokenlocal');
  if (!tokenString) return;
  const bearerToken = extraiBearerToken(tokenString);

  let registros = await db.movimentacaoveiculo.toArray();
  registros = registros.filter((m) => m.movdeletar);

  for (const item of registros) {
    if (item.movidnuvem) {
      try {
        await apirecebimentoweb.delete(`/movimentacaoveiculo/${item.movidnuvem}`, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
          },
        });
      } catch (err) {
        console.error('Erro ao deletar movimentacaoveiculo na API:', err.response?.data || err.message || err);
      }
    }
    await db.movimentacaoveiculo.delete(item.id);
  }
}
